import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { distinctUntilChanged, Subscription } from "rxjs";
import { SessionService } from "../services/session.service";

@Injectable()
export class IsAuthenticatedGuard {
  public router: Router;
  public session: SessionService;

  public constructor() {
    this.router = inject(Router);
    this.session = inject(SessionService);
  }

  public async canActivate(): Promise<Subscription> {
    return this.session.authenticated.pipe(distinctUntilChanged()).subscribe((authenticated) => {
      if (authenticated == false) {
        if (this.router.url.startsWith("/app")) {
          this.router.navigate(["logout"]);
        } else {
          this.router.navigate(["login"]);
        }
      }
    });
  }

  public async canActivateChild(): Promise<Subscription> {
    return this.canActivate();
  }
}
